import { produce } from "immer";
import {
  GET_STEPS,
  GET_STEPS_FAILURE,
  GET_STEPS_SUCCESS,
  SET_CURRENT_STEP,
  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
  GET_PERSONAL_INFO,
  GET_PERSONAL_INFO_SUCCESS,
  GET_PERSONAL_INFO_FAILURE,
  SET_PERSONAL_INFO,
  SET_PERSONAL_INFO_SUCCESS,
  SET_PERSONAL_INFO_FAILURE,
  GET_PAYROLL_INFO,
  GET_PAYROLL_INFO_SUCCESS,
  GET_PAYROLL_INFO_FAILURE,
  SET_PAYROLL_INFO,
  SET_PAYROLL_INFO_SUCCESS,
  SET_PAYROLL_INFO_FAILURE,
  VALIDATE_EMPLOYEE,
  VALIDATE_EMPLOYEE_SUCCESS,
  VALIDATE_EMPLOYEE_FAILURE,
  GET_STEP_DATA,
  GET_STEP_DATA_SUCCESS,
  GET_STEP_DATA_FAILURE,
  SET_FIELDS,
  SAVE_RESPONSE,
  SAVE_RESPONSE_SUCCESS,
  SAVE_RESPONSE_FAILURE,
  DELETE_ANSWER,
  DELETE_ANSWER_SUCCESS,
  DELETE_ANSWER_FAILURE,
  UPDATE_STATUS,
  UPDATE_STATUS_SUCCESS,
  UPDATE_STATUS_FAILURE,
  GET_REQUIRED_DOCS,
  GET_REQUIRED_DOCS_SUCCESS,
  GET_REQUIRED_DOCS_FAILURE,
} from "./constants";

export const staticOnboardingSteps = [
  { title: "Set Password", is_static: true, id: 1 },
  { title: "Personal Details", is_static: true, id: 2 },
  { title: "Payroll Details", is_static: true, id: 3 },
];

export const initialState = {
  isFetchingSteps: false,
  steps: [staticOnboardingSteps[0]],
  currentStep: 1,
  //
  isSettingPassword: false,
  isFetchingInfo: false,
  // Personal Info
  personalInfo: null,
  isSettingPersonalInfo: false,
  // Payroll Info
  payrollInfo: null,
  isFetchingPayrollInfo: false,
  isSettingPayrollInfo: false,
  // Validate Employee
  isValidating: false,
  isValidated: false,
  validateData: null,
  // Step Data
  isFetchingStepData: false,
  stepData: null,
  // Set Fields
  fields: [],
  // Required Docs
  requiredDocs: [],
  isFetchingRequiredDocs: false,
};

const EmployeeOnboardReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_STEPS:
        draft.isFetchingSteps = true;
        break;
      case GET_STEPS_SUCCESS:
        draft.isFetchingSteps = false;
        draft.steps = action.payload;
        break;
      case GET_STEPS_FAILURE:
        draft.isFetchingSteps = false;
        break;
      case SET_CURRENT_STEP:
        draft.currentStep = action.payload;
        break;
      case SET_PASSWORD:
        draft.isSettingPassword = true;
        break;
      case SET_PASSWORD_SUCCESS:
        draft.isSettingPassword = false;
        break;
      case SET_PASSWORD_FAILURE:
        draft.isSettingPassword = false;
        break;
      case GET_PERSONAL_INFO:
        draft.isFetchingInfo = true;
        break;
      case GET_PERSONAL_INFO_SUCCESS:
        draft.isFetchingInfo = false;
        draft.personalInfo = action.payload;
        break;
      case GET_PERSONAL_INFO_FAILURE:
        draft.isFetchingInfo = false;
        break;
      case SET_PERSONAL_INFO:
        draft.isSettingPersonalInfo = true;
        break;
      case SET_PERSONAL_INFO_SUCCESS:
        draft.isSettingPersonalInfo = false;
        break;
      case SET_PERSONAL_INFO_FAILURE:
        draft.isSettingPersonalInfo = false;
        break;
      case GET_PAYROLL_INFO:
        draft.isFetchingPayrollInfo = true;
        break;
      case GET_PAYROLL_INFO_SUCCESS:
        draft.isFetchingPayrollInfo = false;
        draft.payrollInfo = action.payload;
        break;
      case GET_PAYROLL_INFO_FAILURE:
        draft.isFetchingPayrollInfo = false;
        break;
      case SET_PAYROLL_INFO:
        draft.isSettingPayrollInfo = true;
        break;
      case SET_PAYROLL_INFO_SUCCESS:
        draft.isSettingPayrollInfo = false;
        break;
      case SET_PAYROLL_INFO_FAILURE:
        draft.isSettingPayrollInfo = false;
        break;
      case VALIDATE_EMPLOYEE:
        draft.isValidating = true;
        draft.isValidated = false;
        break;
      case VALIDATE_EMPLOYEE_SUCCESS:
        draft.isValidating = false;
        draft.validateData = action.payload ? action.payload : null;
        draft.isValidated = true;
        break;
      case VALIDATE_EMPLOYEE_FAILURE:
        draft.isValidating = false;
        draft.isValidated = false;
        break;
      case GET_STEP_DATA:
        draft.isFetchingStepData = true;
        break;
      case GET_STEP_DATA_SUCCESS:
        draft.isFetchingStepData = false;
        draft.stepData = action.payload;
        break;
      case GET_STEP_DATA_FAILURE:
        draft.isFetchingStepData = false;
        break;
      case SET_FIELDS:
        draft.fields = action.payload;
        break;
      case SAVE_RESPONSE:
        draft.isSavingResponse = true;
        break;
      case SAVE_RESPONSE_SUCCESS:
        draft.isSavingResponse = false;
        break;
      case SAVE_RESPONSE_FAILURE:
        draft.isSavingResponse = false;
        break;
      case DELETE_ANSWER:
        draft.isDeletingAnswer = true;
        break;
      case DELETE_ANSWER_SUCCESS:
        draft.isDeletingAnswer = false;
        break;
      case DELETE_ANSWER_FAILURE:
        draft.isDeletingAnswer = false;
        break;
      case UPDATE_STATUS:
        draft.isUpdatingStatus = true;
        break;
      case UPDATE_STATUS_SUCCESS:
        draft.isUpdatingStatus = false;
        break;
      case UPDATE_STATUS_FAILURE:
        draft.isUpdatingStatus = false;
        break;
      case GET_REQUIRED_DOCS:
        draft.isFetchingRequiredDocs = true;
        draft.requiredDocs = [];
        break;
      case GET_REQUIRED_DOCS_SUCCESS:
        draft.isFetchingRequiredDocs = false;
        draft.requiredDocs = action.payload;
        break;
      case GET_REQUIRED_DOCS_FAILURE:
        draft.isFetchingRequiredDocs = false;
        draft.requiredDocs = [];
        break;
      default:
        return state;
    }
  });

export default EmployeeOnboardReducer;
